type TemperatureUnit = 'celsius' | 'fahrenheit' | 'kelvin' | 'reaumur' | 'rankine';

export function convertTemperature(value: number, fromUnit: TemperatureUnit, toUnit: TemperatureUnit): number {
  // First convert to Kelvin
  let kelvin: number;
  
  switch (fromUnit) {
    case 'celsius':
      kelvin = value + 273.15;
      break;
    case 'fahrenheit':
      kelvin = (value + 459.67) * 5/9;
      break;
    case 'kelvin':
      kelvin = value;
      break;
    case 'reaumur':
      kelvin = value * 1.25 + 273.15;
      break;
    case 'rankine':
      kelvin = value * 5/9;
      break;
    default:
      throw new Error('Invalid temperature unit');
  }

  // Then convert from Kelvin to target unit
  switch (toUnit) {
    case 'celsius':
      return kelvin - 273.15;
    case 'fahrenheit':
      return kelvin * 9/5 - 459.67;
    case 'kelvin':
      return kelvin;
    case 'reaumur':
      return (kelvin - 273.15) * 0.8;
    case 'rankine':
      return kelvin * 1.8;
    default:
      throw new Error('Invalid temperature unit');
  }
}